import { KipUser } from "./KipUser";

export class KipUserGroup {
  UserGroupId:number;
  Subscriber: string;
  HotelId: number;
  UserGroupName:string;
  Users : Array<KipUser>;
}